var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddInvoiceIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0781 6.57617V8.99617C22.0781 10.5762 21.0781 11.5762 19.4981 11.5762H16.0781V4.58617C16.0781 3.47617 16.9881 2.57617 18.0981 2.57617C19.1881 2.58617 20.1881 3.02617 20.9081 3.74617C21.6281 4.47617 22.0781 5.47617 22.0781 6.57617Z",
    stroke: "#3876BB",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.07812 7.43467V21.0385C2.07812 21.845 3.01813 22.3017 3.67813 21.8158L5.38812 20.572C5.78812 20.2805 6.34813 20.3194 6.70813 20.6692L8.36812 22.292C8.75812 22.6709 9.39813 22.6709 9.78813 22.292L11.4681 20.6595C11.8181 20.3194 12.3781 20.2805 12.7681 20.572L14.4781 21.8158C15.1381 22.292 16.0781 21.8353 16.0781 21.0385V4.51957C16.0781 3.4507 16.9781 2.57617 18.0781 2.57617H7.07812H6.07812C3.07812 2.57617 2.07812 4.31551 2.07812 6.46297V7.43467Z",
    stroke: "#3876BB",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.32812 10.5762H11.8281",
    stroke: "#3876BB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07812 13.3262V7.82617",
    stroke: "#3876BB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddInvoiceIcon);
export default __webpack_public_path__ + "static/media/AddInvoiceIcon.fe5025570f3fc507937362b8bc11eb9e.svg";
export { ForwardRef as ReactComponent };